import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ChildStore {

  private _childs:Array<Object>;
  set childs(childs:Array<Object>){
    this._childs = childs;
  }
  get childs(){
    return this._childs;
  }
}


// WEBPACK FOOTER //
// ./src/stores/child-store.ts